import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { addVideoBlob, addVideoBlobAvatars, addVideoBlobBefore } from '../../store/videoSlice';

export default function VideoToBlob({ step, steps }) {

    const dispatch = useDispatch();

    const videosBefore = [
        { id: 'sell_smarter', video: process.env.REACT_APP_BASENAME + '/video/video-avatars/cream-video-01.mp4' },
    ];




    const videoBlobsBefore = useSelector((state) => state.videos.blobsBefore);
    useEffect(() => {
        const loadVideosToBlob = async () => {
            const currentStepIndex = steps.findIndex((s) => s.id === step.id);
            if (currentStepIndex === -1) return;
            for (const video of videosBefore) {
                if (videoBlobsBefore[video.id]) continue;
                const videoStepIndex = steps.findIndex((s) => s.id === 'sell_smarter');
                if (currentStepIndex > videoStepIndex - 3 && currentStepIndex <= videoStepIndex) {
                    try {
                        console.log(`Loading video: ${video.id}`);
                        const response = await fetch(video.video);

                        if (!response.ok) {
                            throw new Error(`Failed to load video: ${video.video}`);
                        }

                        const blob = await response.blob();
                        const blobUrl = URL.createObjectURL(blob)
                        dispatch(addVideoBlobBefore({ id: video.id, blobUrl }));
                    } catch (error) {
                        console.error(`Error loading video ${video.id}:`, error);
                    }
                }
            }
        };
        loadVideosToBlob();
    }, [dispatch, step]);


    // const videosAvatars = [
    //     { id: 'avatar-video-04', video: '/video/video-avatars/avatar-video-04.mp4' },
    //     { id: 'avatar-video-05', video: '/video/video-avatars/avatar-video-05.mp4' },
    //     { id: 'avatar-video-03', video: '/video/video-avatars/avatar-video-03.mp4' },
    //     { id: 'avatar-video-02', video: '/video/video-avatars/avatar-video-02.mp4' },
    //     { id: 'avatar-video-01', video: '/video/video-avatars/avatar-video-01.mp4' },
    //     { id: 'avatar-video-06', video: '/video/video-avatars/avatar-video-06.mp4' },
    // ];



    // const videoBlobsAvatars = useSelector((state) => state.videos.blobsAvatars);
    // useEffect(() => {
    //     const loadVideosToBlob = async () => {
    //         const currentStepIndex = steps.findIndex((s) => s.id === step.id);
    //         if (currentStepIndex === -1) return;
    //         for (const video of videosAvatars) {
    //             if (videoBlobsAvatars[video.id]) continue;
    //             const videoStepIndex = steps.findIndex((s) => s.id === 'video-ads');
    //             if (currentStepIndex > videoStepIndex - 3 && currentStepIndex <= videoStepIndex) {
    //                 try {
    //                     console.log(`Loading video: ${video.id}`);
    //                     const response = await fetch(video.video);
    //                     if (!response.ok) {
    //                         throw new Error(`Failed to load video: ${video.video}`);
    //                     }
    //                     const blob = await response.blob();
    //                     const blobUrl = URL.createObjectURL(blob)
    //                     dispatch(addVideoBlobAvatars({ id: video.id, blobUrl }));
    //                 } catch (error) {
    //                     console.error(`Error loading video ${video.id}:`, error);
    //                 }
    //             }
    //         }
    //     };
    //     loadVideosToBlob();
    // }, [dispatch, step]);




    const videos = [
        {
            id: 'ss_run_social',
            video: process.env.REACT_APP_BASENAME + '/video/animation/run_social.mp4',
        },
    {
            id: 'ss_shortcut',
            video: process.env.REACT_APP_BASENAME + '/video/animation/Grow_revenue_with_video.mp4',
        },
       
        {
            id: 'ss_cashflow',
            video: process.env.REACT_APP_BASENAME +'/video/animation/social_cashflow.mp4',
        },
{
            id: 'ss_ai_agent',
            video: process.env.REACT_APP_BASENAME +'/video/animation/AI_agent.mp4',
        },
        
        {
            id: 'ss_avatar_library',
            video: process.env.REACT_APP_BASENAME +'/video/animation/Dynamic templates.mp4',
        },

        {
            id: 'ss_batch_content',
            video: process.env.REACT_APP_BASENAME +'/video/animation/Bulk_Ad_Creation).mp4',
        }, 
        {
            id: 'ss_auto_posting',
            video: process.env.REACT_APP_BASENAME +'/video/animation/Killer autoposting feature.mp4',
        }, 
        // {
        //     id: 'ad-reports',
        //     video: process.env.REACT_APP_BASENAME +'/video/animation/Real-time_ad_reports.mp4',
        // }, {
        //     id: 'ad-copilot',
        //     video: process.env.REACT_APP_BASENAME +'/video/animation/AI_copilot.mp4',
        // },
    ]

    const videoBlobs = useSelector((state) => state.videos.blobs);

    useEffect(() => {
        const loadVideosToBlob = async () => {
            const currentStepIndex = steps.findIndex((s) => s.id === step.id);
            if (currentStepIndex === -1) return;
            for (const video of videos) {
                const videoStepIndex = steps.findIndex((s) => s.id === video.id);
                if (videoBlobs[video.id]) continue;
                if (currentStepIndex > videoStepIndex - 3 && currentStepIndex <= videoStepIndex) {
                    try {
                        console.log(`Loading video: ${video.id}`);
                        const response = await fetch(video.video);
                        if (!response.ok) {
                            throw new Error(`Failed to load video: ${video.video}`);
                        }

                        const blob = await response.blob();
                        dispatch(addVideoBlob({ id: video.id, blob }));
                    } catch (error) {
                        console.error(`Error loading video ${video.id}:`, error);
                    }
                }
            }
        };
        loadVideosToBlob();
    }, [dispatch, step]);


    return (
        <></>
    )
}
